export const formatNumber = (num, decimals = 0) => {
  if (num === null || num === undefined) return '-';
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(num);
};

export const formatPhone = (phone) => {
  if (!phone) return '-';
  const cleaned = String(phone).replace(/\D/g, '');
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  return phone;
};

/** National digits for a phone input. Only strips the dial code from pasted/full numbers (>10 digits). */
export const toNationalPhoneDigits = (phone, countryCode = '+1') => {
  const digits = String(phone ?? '').replace(/\D/g, '');
  const codeDigits = String(countryCode ?? '').replace(/\D/g, '');
  // Only strip dial code when value looks like countryCode + national (>10 digits).
  // Avoids blocking national numbers that start with the same digits (e.g. +1 / 1…).
  if (codeDigits && digits.startsWith(codeDigits) && digits.length > 10) {
    return digits.slice(codeDigits.length).slice(0, 10);
  }
  return digits.slice(0, 10);
};

export const toMerchantOtpPayload = (phone, countryCode = '+1') => {
  const digits = String(phone ?? '').replace(/\D/g, '');
  const codeDigits = String(countryCode ?? '').replace(/\D/g, '');
  const phoneNumber =
    codeDigits && digits.startsWith(codeDigits) && digits.length > 10
      ? digits.slice(codeDigits.length)
      : digits;

  return {
    phoneNumber,
    countryCode,
  };
};

export const toMerchantVerifyOtpPayload = (phone, otp, countryCode = '+1') => ({
  otp: String(otp ?? ''),
  ...toMerchantOtpPayload(phone, countryCode),
});

export const truncate = (str, length = 50) => {
  if (!str) return '';
  return str.length > length ? `${str.slice(0, length)}...` : str;
};

export const capitalize = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export default {
  formatNumber,
  formatPhone,
  toNationalPhoneDigits,
  toMerchantOtpPayload,
  toMerchantVerifyOtpPayload,
  truncate,
  capitalize,
};
